angular.module('ihestiaRestServicesBase')
.factory('IHestiaMetaDataModelConstants', ['LsnMetaDataModelConstants', function(LsnMetaDataModelConstants) {
    return LsnMetaDataModelConstants;
  }])
.factory('IHestiaMetaDataModel',[ 'LsnMetaDataModelV1', function(LsnMetaDataModelV1) {
    return LsnMetaDataModelV1;
  }]);